import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent implements OnInit {

  public is_null = false;

  constructor(private route: ActivatedRoute, private http: HttpService) { }

  ngOnInit(): void {
    // this.route.parent.params.subscribe(param => {
    //   if (!param.company_uuid || param.company_uuid === 'null') {
    //     this.is_null = true;
    //   } else {
    //     this.is_null = false;
    //   }
    // })

    // const selected = this.http.getSelectedCompany();
    // if (selected) {
    //   this.http.navigate(['/lo', selected, 'dashboard'])
    // }
  }

}
